import type { ComputedRef, Ref } from 'vue'
import { computed } from 'vue'
import type { CatalogueEngagementRingFragment } from '@/graphql/api'
import type { Breadcrumb } from '@/components/ui/Breadcrumbs.vue'
import { useRoutes } from '@/router/routes'

export function useEngagementRingBreadcrumbs(
    ring: Readonly<Ref<CatalogueEngagementRingFragment | undefined | null>>
): ComputedRef<Breadcrumb[]> {
    const routes = useRoutes()

    return computed<Breadcrumb[]>(() => {
        if (!ring.value) {
            return []
        }
        const shape = ring.value.centreStoneConstraints.shape

        return [
            {
                title: 'Home',
                to: routes.home(),
            },
            {
                title: 'Engagement Rings',
                to: routes.engagementRings({}),
            },
            {
                title: shape.translation.name,
                to: routes.engagementRings({
                    shape: shape.systemCode,
                }),
            },
            {
                title: ring.value?.productName,
            },
        ]
    })
}
